import React, { useState, useEffect, Suspense, lazy } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.webp";
import mobileLogo from "../assets/logo.webp";

// Lazy load GoogleCSE
const GoogleCSE = lazy(() => import("./GoogleCSE"));

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const location = useLocation();

  useEffect(() => {
    setActiveLink(location.pathname);
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen, location.pathname]);

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const handleLinkClick = (link) => {
    setActiveLink(link);
    if (menuOpen) setMenuOpen(false);
  };

  return (
    <header className="navbarMenu">
      <div className="logo-container">
        <a href="/" aria-label="Home">
          <span className="screen-pc-img">
            <img src={logo} alt="Logo of Hirdaramani" className="logo-image" />
          </span>
          <span className="screen-mobile-img">
            <img src={mobileLogo} alt="Mobile Logo" className="logo-image" />
          </span>
        </a>
      </div>

      <div className="nav-search-container">
        <nav className="nav-links">
          <Link
            to="/conserve/"
            className={`nav-link ${
              activeLink === "/conserve/" ? "active" : ""
            }`}
            onClick={() => handleLinkClick("/conserve/")}
          >
            Conserve
          </Link>
          <Link
            to="/empower/"
            className={`nav-link ${activeLink === "/empower/" ? "active" : ""}`}
            onClick={() => handleLinkClick("/empower/")}
          >
            Empower
          </Link>
          <Link
            to="/support/"
            className={`nav-link ${activeLink === "/support/" ? "active" : ""}`}
            onClick={() => handleLinkClick("/support/")}
          >
            Support
          </Link>
          <Link
            to="/trust/"
            className={`nav-link ${activeLink === "/trust/" ? "active" : ""}`}
            onClick={() => handleLinkClick("/trust/")}
          >
            Trust
          </Link>
          <Link
            to="/contact-us/"
            className={`nav-link ${
              activeLink === "/contact-us/" ? "active" : ""
            }`}
            onClick={() => handleLinkClick("/contact-us/")}
          >
            Contact
          </Link>
        </nav>

        <div className="gcc-search-container">
          <Suspense fallback={<div className="search-loading-placeholder" />}>
            <GoogleCSE />
          </Suspense>
        </div>
      </div>

      <span
        className={`hamburger-menu ${menuOpen ? "open" : ""}`}
        onClick={toggleMenu}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === "Enter" && toggleMenu()}
        aria-label={menuOpen ? "Close menu" : "Open menu"}
      >
        {!menuOpen ? (
          <>
            <div className="hamburger-icon" />
            <div className="hamburger-icon" />
            <div className="hamburger-icon" />
          </>
        ) : (
          <div className="close-icon" />
        )}
      </span>

      {menuOpen && (
        <div className="mobile-menu">
          <Link
            to="/conserve/"
            className={`nav-link ${
              activeLink === "/conserve/" ? "active" : ""
            }`}
            onClick={() => handleLinkClick("/conserve/")}
          >
            Conserve
          </Link>
          <Link
            to="/empower/"
            className={`nav-link ${activeLink === "/empower/" ? "active" : ""}`}
            onClick={() => handleLinkClick("/empower/")}
          >
            Empower
          </Link>
          <Link
            to="/support/"
            className={`nav-link ${activeLink === "/support/" ? "active" : ""}`}
            onClick={() => handleLinkClick("/support/")}
          >
            Support
          </Link>
          <Link
            to="/trust/"
            className={`nav-link ${activeLink === "/trust/" ? "active" : ""}`}
            onClick={() => handleLinkClick("/trust/")}
          >
            Trust
          </Link>
          <Link
            to="/contact-us/"
            className={`nav-link ${
              activeLink === "/contact-us/" ? "active" : ""
            }`}
            onClick={() => handleLinkClick("/contact-us/")}
          >
            Contact
          </Link>
          <div className="gcc-search-container">
            <Suspense fallback={<div className="search-loading-placeholder" />}>
              <GoogleCSE />
            </Suspense>
          </div>
          <div style={{ height: "80px" }} />
        </div>
      )}
    </header>
  );
};

export default Navbar;
